<template>
  <div class="p-0 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">

            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>

              <div class="flex justify-center">
                <img
                  v-if="selectedFileUrl || store.state.sectorForm.imageName"
                  :src="selectedFileUrl ?? store.state.sectorForm.imageName"
                  alt="Capa da noticia"
                  class="mt-10 mb-auto rounded-md w-60 max-h-60 hidden md:block"
                />
              </div>
            </div>

            <div class="lg:col-span-2 space-y-3 text-start">

              <!-- Título -->
              <div class="" id="form-fields">
                <label class="block mb-2 text-sm font-semibold text-gray-700">Título da Notícia</label>
                <input
                  v-model="store.state.sectorForm.title"
                  type="text"
                  class="w-full px-4 py-2 text-sm text-gray-800 placeholder-gray-400 bg-white border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Digite o título da notícia"
                  required
                >
                <span name="title" class="text-red-600 text-sm" />
              </div>

              <!-- Categoria -->
              <div class="">
                <label class="block mb-2 text-sm font-semibold text-gray-700">Categoria</label>
                <select
                  v-model="store.state.sectorForm.category"
                  class="w-full px-4 py-2 text-sm text-gray-800 bg-white border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                >
                  <option disabled value="">Selecione uma categoria</option>
                  <option>Esportes</option>
                  <option>Eventos</option>
                  <option>Resultados</option>
                  <option>Política</option>
                  <option>Entretenimento</option>
                  <option>Tecnologia</option>
                  <option>Economia</option>
                  <option>Saúde</option>
                  <option>Outros</option>
                </select>
              </div>

              <!-- Resumo -->
              <div class="mb-6">
                <label class="block mb-2 text-sm font-semibold text-gray-700">Resumo da Notícia</label>
                <textarea
                  v-model="store.state.sectorForm.resum"
                  rows="3"
                  class="w-full px-4 py-2 text-sm text-gray-800 placeholder-gray-400 bg-white border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Escreva um pequeno resumo ou descrição"
                  required
                ></textarea>
              </div>

              <!-- imagem -->
                <div class="flex justify-center">
                  <img
                    v-if="selectedFileUrl"
                    :src="selectedFileUrl"
                    alt="Capa da noticia"
                    class="rounded-md w-60 max-h-60 block md:hidden"
                  />
                </div>

                <!-- imagem -->
                <div class="md:col-span-5 flex h-10">
                  <label
                    class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[10rem] pt-2.5 h-10 rounded-l-md rounded-r-none"
                  >
                    <div class="flex my-auto h-full">
                      <div class="w-full my-auto flex justify-center h-full">
                        <component
                          :is="selectedFileName ? PhFileImage : PhImage"
                          class="w-5 h-5 mr-1"
                          :class="[
                            selectedFileName ? 'text-green-500' : 'text-gray-500'
                          ]"
                        />

                        Capa da noticia
                      </div>
                    </div>
                    <input
                      type="file"
                      class="hidden"
                      @change="handleFileChange"
                    />
                  </label>
                  <input
                    type="text"
                    style="padding-left: 10px !important"
                    class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                    :value="selectedFileName"
                  />
                </div>

              <!-- Conteúdo da Notícia -->
              <div>
                <!-- <label class="block mb-2 text-sm font-medium text-gray-700">Conteúdo da Notícia</label> -->
                <BlogEditor />
              </div>

              <!-- Botão de Salvar -->
              <div class="text-right flex justify-center md:justify-end">
                <slot />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../utils/CleanInputButton.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import BlogEditor from '@/components/BlogEditor.vue'
import { sectorPriority } from '../lookups/form'
import { dataExtinguisher } from '../store'
import {
  PhFileImage,
  PhImage
} from '@phosphor-icons/vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { markRaw } from 'vue'

export default ({
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
    BlogEditor,
    PhFileImage,
    PhImage
  },
  props: {
    descriptionTitle: String
  },
  data () {
    const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
    const store = dataExtinguisher

    return {
      PhFileImage,
      PhImage,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataExtinguisher.state,
      dataExtinguisher,
      sectorPriority,
      fileUrl,
      toast,
      markRaw,

      store
    }
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (allowedExtensions.includes(fileExtension)) {
          this.selectedFileName = file.name
          this.selectedFileUrl = URL.createObjectURL(file)

          this.store.state.sectorForm.imageName = this.selectedFileName
          this.store.state.sectorForm.image = file
        } else {
          return this.toast(
            'Aviso: ',
            'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas',
            'info'
          )
        }
      }
    }
  }
})
</script>
